<mwe-product-tariff-card-template
  [product]="product()"
  [headlineReference]="headlineService.getHeadline(0)"
  [hasContent]="true"
  [hasActions]="isTariffChangeAvailable()"
  data-test="tariff-card-emobility"
>
  <mwe-infobox messageKey="products.details.card.priceInfo" type="neutral" />

  <ng-container slot="actions">
    <div class="text-center">
      <mwe-button-link
        (clicked)="startTariffChange()"
        [label]="'products.details.tariffCard.tariffChange'"
        [ariaLabel]="'products.details.tariffCard.tariffChange'"
        dataTest="tariff-price-card-tariff-change"
      />
    </div>
  </ng-container>
</mwe-product-tariff-card-template>
